export const MotionDuration = {
  INSTANT: 150,       // 150ms - Micro-interactions
  SHORT: 250,         // 250ms - Quick transitions
  MEDIUM: 350,        // 350ms - Standard transitions
  LONG: 450,          // 450ms - Complex transitions
  CONTROLS_FADE: 300, // 300ms - Controls show/hide
  IMAGE_SLIDE: 500,   // 500ms - Directional image entry
} as const;

export const MotionEasing = {
  ENTER: 'cubic-bezier(0.33, 1, 0.68, 1)', // easeOutCubic
  
  DEFAULT: 'cubic-bezier(0.76, 0, 0.24, 1)', // easeInOutQuart
} as const;

export const SwipeThresholds = {
  DISTANCE: 50,   // 50px horizontal movement
  VELOCITY: 500,  // 500px/s
} as const;